import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { getRacingSearchResults } from './racingSearchApi'

export const racingSearchQuery = ({
  searchTerm,
  isEnabled,
}: {
  searchTerm: string
  isEnabled: boolean
}) =>
  queryOptions({
    queryKey: [...queryKeys.searchRacingBase, searchTerm],
    queryFn: () => getRacingSearchResults(searchTerm),
    staleTime: 1_000 * 60 * 1, // 1min
    gcTime: 1_000 * 60 * 1,
    enabled: isEnabled && !!searchTerm && searchTerm.length > 2,
  })
